<template>
  <div class="samples-view">
    <samples-filter ref="samplesFilter" />

    <samples-list
      @requestSamplesListUpdate="handleRequestSamplesListUpdate"
    />
  </div>
</template>

<script>
import SamplesFilter from './SamplesFilter'
import SamplesList from './SamplesList'

export default {
  name: 'Samples',
  components: {
    SamplesFilter,
    SamplesList
  },
  methods: {
    handleRequestSamplesListUpdate() {
      this.$refs.samplesFilter.submitSearch()
    }
  }
}
</script>
